<template lang="html">
  <div class="contact-component">
    <br>
    <v-container>
<v-row>
  <v-col cols="12" md="8">
      <v-card
        class="mx-auto"
        max-width="800"
      >

        <v-card-title>
          Küldje el, miben segíthetünk?
        </v-card-title>
        <v-container>
          <v-form
            ref="contact_form"
            v-model="contact_valid"
          >
        <v-row>
          <v-col
            cols="12"
          >
            <v-text-field
              outlined
              v-model="contact_name"
              label="Kapcsolattartó"
              :rules="required"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
          >
            <v-text-field
              outlined
              v-model="contact_company"
              label="Cégnév"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
          >
            <v-text-field
              outlined
              v-model="contact_email"
              label="E-mail címe"
              :rules="emailRules"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
          >
            <v-text-field
              outlined
              v-model="contact_phone"
              label="Telefonszám"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
          >
            <v-textarea
              v-model="contact_message"
              outlined
              name="input-7-4"
              label="Üzenet"
              :rules="required"
            ></v-textarea>
          </v-col>
          <v-col cols="12">
           <v-checkbox
             v-model="adatkezeles"
           >
           <template v-slot:label>
             <div>
               A küldéssel elfogadom az
                   <a
                     target="_blank"
                     href="https://szoftverfejlesztes.csigaver.hu/adatkezelesi_tajekoztato.pdf"
                     @click.stop
                   >
                     Adatkezelési tájékoztatóban
                   </a>
                 foglaltakat!
               </div>
             </template>
           </v-checkbox>
           </v-col>
        </v-row>
        </v-form>
        </v-container>
        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn
            outlined
            color="red"
            :disabled="!contact_valid || !adatkezeles || mail_loader"
            :loading="mail_loader"
            @click="Send()"
          >
            Küldés
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-col>

<v-col cols="12" md="4">
  <v-card
    max-width="350"
    max-height="450"
    class="mx-auto"
    shaped
  >
        <v-card-title>
          Deák Attila e.v.
        </v-card-title>

    <v-list>
      <v-list-item href="tel:36703350312">
        <v-list-item-icon>
          <v-icon color="indigo">
            mdi-phone
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>(+36) 70-335-0412</v-list-item-title>
        </v-list-item-content>

      </v-list-item>

      <v-divider inset></v-divider>

      <v-list-item href="mailto:fejlesztes@csigaver.hu">
        <v-list-item-icon>
          <v-icon color="indigo">
            mdi-email
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>fejlesztes@csigaver.hu</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

    </v-list>
  </v-card>
  </v-col>
</v-row>

    </v-container>

    <v-snackbar
      v-model="error_snackbar"
      color="red"
    >
      {{ error_message }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="error_snackbar = false"
        >
          bezár
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar
      v-model="success_snackbar"
    >
      {{ success_message }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="success_snackbar = false"
        >
          bezár
        </v-btn>
      </template>
    </v-snackbar>

  </div>
</template>

<script>
  export default {
    data: () => ({
      contact_valid: true,
      required: [
        v => !!v || 'A mező kitöltése kötelező!'
      ],
      emailRules: [
        v => !!v || 'A mező kitöltése kötelező!',
        v => /.+@.+\..+/.test(v) || 'Az e-mail cím formátuma nem megfelelő!',
      ],
      recaptcha_token: '',
      contact_name: '',
      contact_company: '',
      contact_email: '',
      contact_phone: '',
      contact_message: '',
      mail_loader: false,
      error_snackbar: false,
      error_message: '',
      success_message: '',
      success_snackbar: false,
      adatkezeles: false,
    }),
    methods: {
      async recaptcha() {
        // (optional) Wait until recaptcha has been loaded.
        await this.$recaptchaLoaded()

        // Execute reCAPTCHA with action "login".
        this.recaptcha_token = await this.$recaptcha('send')

        // Do stuff with the received token.
        //console.log(this.recaptcha_token);
      },
      Send: async function() {
        this.mail_loader = true;
        await this.recaptcha()
        this.$http.post('/send_contractForm', {
        token: this.recaptcha_token,
        contact_name: this.contact_name,
        contact_company: this.contact_company,
        contact_email: this.contact_email,
        contact_phone: this.contact_phone,
        contact_message: this.contact_message
        })
        .then((response) => {
          this.mail_loader = false;
          if (response.data['success'] == true) {
            this.success_message = response.data['message'];
            this.success_snackbar = true;
            this.formReset();
          } else {
            this.error_message = response.data['message'];
            this.error_snackbar = true;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      },
      formReset () {
        this.$refs.contact_form.reset()
      },
    },
    watch: {

    },
    mounted() {

    }
  }
</script>

<style lang="css">
</style>
